import { RootAppState } from "store/configureStore";
import { bomItemNameSelector } from "./bomItemNameSelector";
import { BomItemPointer } from "model/Project/BomItemPointer";

export const bomItemsNamesSelector = (bomItemPointers: BomItemPointer[]) => (state: RootAppState) => {
    const bomItemsNames = bomItemPointers.map(bomItemPointer => bomItemNameSelector(bomItemPointer)(state));
   
    return bomItemsNames;
}